import { render, staticRenderFns } from "./panel-monitor.vue?vue&type=template&id=28f66886&scoped=true"
import script from "./panel-monitor.vue?vue&type=script&lang=js"
export * from "./panel-monitor.vue?vue&type=script&lang=js"
import style0 from "./panel-monitor.vue?vue&type=style&index=0&id=28f66886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f66886",
  null
  
)

export default component.exports